import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-quality',
  templateUrl: './quality.component.html',
  styleUrls: ['./quality.component.css']
})
export class QualityComponent implements OnInit {

  form;
  ngOnInit () {

    this.form = new FormGroup ( {

    value1: new FormControl(''),
    value2: new FormControl(''),
    } )

  } 
  qua(n1,n2){
    var qual=n1/n2;
    var qualpercent= qual*100;
    var qualsimple= qualpercent.toFixed(2);
    return qual ;
    }

}



// WEBPACK FOOTER //
// C:/my-dream-app/src/app/quality/quality.component.ts